<template>

  <!-- full size card START -->
  <v-card id="dataset-card" color="grey lighten-4" hover height="100%" :to="{ name: 'Dataset', params: { name: dataset.name }}" v-if="!minimized">
    <v-card-title primary-title >
      <div class="headline secondary--text" v-bind:class="{ 'grey--text': (!dataset.enabled) }">
        <v-icon :color="$appConfig.dataset.color">{{$appConfig.dataset.icon}}</v-icon> {{dataset.name}} 
      </div>
        <v-spacer></v-spacer>
        <v-icon>mdi-arrow-right</v-icon>
      <v-flex xs12>
        <div class="grey--text caption">Updated: {{dataset.updated_at}}</div>
      </v-flex>
      <v-flex v-if="dataset.description">
        <div class="subheading">{{dataset.description}}</div>
      </v-flex>
      <v-flex xs12>
      <template v-for='(label, index) in dataset.labels'>
        <v-chip label outlined :key="index">{{label.name}}</v-chip>
      </template>
      <template v-if='!dataset.labels.length'>
        <v-chip label outlined>No label</v-chip>
      </template>      
      </v-flex>
    </v-card-title>
    <v-divider ></v-divider>
    <v-card-text>
      <v-container grid-list-md text-xs-center class="pa-1">
        <v-layout wrap>
          <v-flex xs4>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-icon v-on="on">mdi-view-headline</v-icon>
                <span v-if="dataset.nb_lines">{{dataset.nb_lines}} lines</span>
                <span v-else>-</span>
                </template>
              <span>Number of documents</span>
            </v-tooltip>
          </v-flex>
          <v-flex xs4>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-icon v-bind:class="{ 'success--text': dataset.enabled }" v-on="on">mdi-white-balance-sunny</v-icon>
                <v-spacer></v-spacer>
                <span v-if="dataset.enabled" class="success--text">All good!</span>
                <span v-else class="warning--text" >Disabled</span>    
              </template>
              <span>Dataset status</span>
            </v-tooltip>
          </v-flex>
          <v-flex xs4>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-icon v-on="on">mdi-account-group</v-icon>
                <v-spacer></v-spacer>
                <span v-if="dataset.nb_users">{{dataset.nb_users}} people</span>
                <span v-else>no people</span>
              </template>
              <span>Members with access</span>
            </v-tooltip>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
  </v-card>
  <!-- full size card END -->

  <!-- minimized card START -->
  <v-card flat :to="{name: 'Dataset', params: { name: dataset.name }}" style="border-bottom:1px solid lightgray;border-radius:0px" v-else>
    <v-card-text>
      <v-icon :color="$appConfig.dataset.color">{{$appConfig.dataset.icon}}</v-icon> {{dataset.name}} 
      <v-icon style="position: absolute;left:94%">mdi-arrow-right</v-icon>
    </v-card-text>
  </v-card>
  <!-- minimized card END -->

</template>
<script>
  export default {
    props: {
      dataset: {},
      minimized: {
        type: Boolean,
        default: false
      },
    },
    data () {
      return {
      }
    },
    methods: {
    }
  }

</script>
